




















































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import Device from './Device.vue'

@Component({
  components: {
    Device,
  },
  computed: {
    ...mapGetters('buildergpt', ['getApp']),
    ...mapGetters('currency', ['getCurrency']),
  },
})
export default class AppExamplePromoPage extends Vue {
  @Prop({ required: true, type: String }) color!: string
  @Prop({ required: true, type: String }) avatar!: string
  @Prop({ required: true, type: String }) name!: string
  @Prop({ required: true, type: Array }) tariffs!: any
  @Prop({ required: true, type: Boolean }) isActive!: boolean
  getApp!: any
  getCurrency!: any
  get appCurrencySymbol(): string {
    return this.getCurrency.items.find((item) => item.code === this.getApp.currency).symbol
  }
  get trial() {
    return this.appCurrencySymbol === '₽' ? this.tariffs.find(({ frequency }) => frequency === 2) : this.tariffs.find(({ frequency }) => frequency === 3)
  }
  get monthTariff() {
    return this.tariffs.find(({ frequency }) => frequency === 3)
  }
  get weekTariff() {
    return this.tariffs.find(({ frequency }) => frequency === 2)
  }
  get halfYearTariff() {
    return this.tariffs.find(({ frequency }) => frequency === 5)
  }
}
